export const themeKeys = {
  themesAll: ['THEMES'] as const,
  themes: (documentSuperId: number | string | undefined) => ['THEMES', documentSuperId] as const,
  diffAll: ['THEME_DIFF'] as const,
  diff: (themeId: string | undefined, documentSuperId: number | string | undefined) => ['THEME_DIFF', themeId, documentSuperId] as const,
  appliedStatusAll: ['THEME_APPLIED_STATUS'] as const,
  appliedStatus: (documentSuperId: number | string | undefined) => ['THEME_APPLIED_STATUS', documentSuperId] as const,
};
